export default __webpack_public_path__ + "static/media/gallery_02.1b3cb346.jpg";